/* ============================================================
   Bariera — logika motywu
   Heading, menu mobilne, kursor, karuzela pozioma, spotlight,
   zakładki składników, wybór wariantu, koszyk AJAX (szuflada).
   ============================================================ */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hoverable = window.matchMedia("(hover: hover)").matches;
  var routes = window.routes || {};
  var cartAddUrl = routes.cart_add_url || "/cart/add";
  var cartChangeUrl = routes.cart_change_url || "/cart/change";

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // Panele w naglowku musza sie wzajemnie zamykac. Uchwyty deklarujemy tutaj,
  // bo kazdy panel jest inicjowany w swoim bloku nizej.
  var closeSearch = function () {};
  var closeAcct = function () {};

  /* ---------------- nagłówek ---------------- */
  var header = $(".site-header");
  var burger = $("[data-burger]");
  var mobileNav = $("#mobile-nav");

  function setMobileNav(open) {
    if (!mobileNav || !burger) return;
    mobileNav.hidden = !open;
    burger.setAttribute("aria-expanded", String(open));
    document.body.style.overflow = open ? "hidden" : "";
  }

  if (burger && mobileNav) {
    burger.addEventListener("click", function () {
      setMobileNav(mobileNav.hidden);
    });
    // zamknij po wybraniu pozycji
    mobileNav.addEventListener("click", function (e) {
      if (e.target.closest("a")) setMobileNav(false);
    });
  }

  // rozwijane menu: hover i focus obsługuje CSS, tu tylko dotyk i klawiatura
  $$("[data-sub]").forEach(function (item) {
    var trigger = $(".nav-link", item);
    if (!trigger) return;

    trigger.addEventListener("click", function (e) {
      // na urządzeniach dotykowych pierwsze dotknięcie rozwija, drugie przechodzi dalej
      if (!window.matchMedia("(hover: hover)").matches && !item.classList.contains("open")) {
        e.preventDefault();
        $$("[data-sub]").forEach(function (o) { if (o !== item) o.classList.remove("open"); });
        item.classList.add("open");
        trigger.setAttribute("aria-expanded", "true");
      }
    });

    item.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        item.classList.remove("open");
        trigger.setAttribute("aria-expanded", "false");
        trigger.focus();
      }
    });

    item.addEventListener("focusin", function () { trigger.setAttribute("aria-expanded", "true"); });
    item.addEventListener("focusout", function () {
      if (!item.contains(document.activeElement)) trigger.setAttribute("aria-expanded", "false");
    });
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-sub]")) {
      $$("[data-sub].open").forEach(function (o) {
        o.classList.remove("open");
        var t = $(".nav-link", o);
        if (t) t.setAttribute("aria-expanded", "false");
      });
    }
  });

  // znacznik pustego koszyka — chowa plakietkę z liczbą
  function syncCartBadge() {
    var n = parseInt(($("[data-cart-count]") || {}).textContent, 10) || 0;
    $$(".cart-btn").forEach(function (b) { b.setAttribute("data-empty", String(n === 0)); });
  }
  syncCartBadge();

  /* ---------------- karuzela pozioma ---------------- */
  var rails = $$(".rail");

  function sizeRails() {
    if (reduce) return;
    rails.forEach(function (rail) {
      var track = $(".rail-track", rail);
      if (!track) return;
      var extra = track.scrollWidth - window.innerWidth;
      // Nie ma czego przesuwac -> nie rezerwujemy ekranu wysokosci na
      // przewijanie. Sekcja wraca do zwyklego ukladu, zamiast zostawiac pustke.
      if (extra <= 24) {
        rail.classList.add("flat");
        rail.style.height = "";
        track.style.transform = "";
        return;
      }
      rail.classList.remove("flat");
      rail.style.height = Math.max(window.innerHeight * 1.2, extra + window.innerHeight * 0.9) + "px";
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (header) header.classList.toggle("stuck", window.scrollY > 40);
      if (reduce) return;
      rails.forEach(function (rail) {
        var track = $(".rail-track", rail);
        if (!track) return;
        var span = rail.offsetHeight - window.innerHeight;
        if (span <= 0) return;
        var prog = Math.min(1, Math.max(0, -rail.getBoundingClientRect().top / span));
        var dist = Math.max(0, track.scrollWidth - window.innerWidth + 24);
        track.style.transform = "translate3d(" + (-prog * dist).toFixed(1) + "px,0,0)";
      });
    });
  }

  sizeRails();
  window.addEventListener("resize", sizeRails);
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------------- spotlight: bloki opowieści ---------------- */
  if ("IntersectionObserver" in window) {
    $$(".spot").forEach(function (spot) {
      var blocks = $$(".blk", spot);
      var halo = $(".halo", spot);
      if (!blocks.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          blocks.forEach(function (b) { b.classList.toggle("on", b === en.target); });
          if (halo) {
            var i = blocks.indexOf(en.target);
            halo.style.opacity = [0.5, 0.24, 0.72][i % 3];
            halo.style.transform = ["none", "scale(1.25)", "scale(0.85)"][i % 3];
          }
        });
      }, { rootMargin: "-42% 0px -42% 0px" });
      blocks.forEach(function (b) { io.observe(b); });
    });
  }

  /* ---------------- zakładki składników aktywnych ---------------- */
  $$("[data-actives]").forEach(function (root) {
    var buttons = $$("[data-active-tab]", root);
    var panels = $$("[data-active-panel]", root);
    if (!buttons.length) return;
    function show(idx) {
      buttons.forEach(function (b) { b.setAttribute("aria-selected", String(b.dataset.activeTab === idx)); });
      panels.forEach(function (p) { p.hidden = p.dataset.activePanel !== idx; });
    }
    root.addEventListener("click", function (e) {
      var b = e.target.closest("[data-active-tab]");
      if (b) show(b.dataset.activeTab);
    });
    show(buttons[0].dataset.activeTab);
  });

  /* ---------------- wybór wariantu ---------------- */
  $$("[data-variant-picker]").forEach(function (picker) {
    var form = picker.closest("form");
    if (!form) return;
    var idInput = $('[name="id"]', form);
    var productRoot = form.closest("[data-product-media]") || form.parentNode;
    var priceEl = $("[data-product-price-display]", productRoot);
    var addBtn = $('[type="submit"]', form);

    function selectVariantButton(b) {
      if (!b || b.disabled) return;

      $$("button[data-variant-id]", picker).forEach(function (x) {
        x.classList.toggle("on", x === b);
        x.setAttribute("aria-pressed", x === b ? "true" : "false");
      });

      if (idInput) {
        idInput.value = b.dataset.variantId;
        idInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (priceEl && b.dataset.variantPrice) {
        var compareAt = b.dataset.variantCompareAt || "";
        priceEl.innerHTML = compareAt
          ? "<s>" + compareAt + "</s> " + b.dataset.variantPrice
          : b.dataset.variantPrice;
      }

      if (addBtn) {
        var avail = b.dataset.variantAvailable === "true";
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldOut;
      }

      // Keep the selected variant in the URL without reloading the page.
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", b.dataset.variantId);
        window.history.replaceState({}, "", url.toString());
      } catch (err) {}
    }

    picker.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-variant-id]");
      if (!b || !picker.contains(b)) return;
      selectVariantButton(b);
    });
  });

  /* ---------------- licznik sztuk ---------------- */
  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-qty-step]");
    if (!step) return;
    var input = $("input", step.parentNode);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(step.dataset.qtyStep, 10);
    input.value = Math.max(1, v);
  });

  /* ---------------- koszyk ---------------- */
  var drawer = $("#cart-drawer");
  var scrim = $("#cart-scrim");
  var drawerBody = $("#cart-drawer-body");
  var useDrawer = !!(drawer && drawerBody);

  function openCart(open) {
    if (!drawer) return;
    if (open) { closeSearch(); closeAcct(); }
    drawer.classList.toggle("open", open);
    if (scrim) scrim.classList.toggle("on", open);
    document.body.style.overflow = open ? "hidden" : "";
  }

  function refreshDrawer() {
    return fetch("/?section_id=cart-drawer", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("#cart-drawer-body") || doc.querySelector("[data-cart-body]");
        if (fresh && drawerBody) drawerBody.innerHTML = fresh.innerHTML;
        var countEl = doc.querySelector("[data-cart-count]");
        if (countEl) {
          $$("[data-cart-count]").forEach(function (el) { el.textContent = countEl.textContent; });
          var n = parseInt(countEl.textContent, 10) || 0;
          var label = n === 1 ? "produkt" : (n >= 2 && n <= 4 ? "produkty" : "produktów");
          $$("[data-cart-drawer-count]").forEach(function (el) { el.textContent = n + " " + label; });
        }
        syncCartBadge();
      });
  }

  function addToCart(payload, button) {
    var original = button ? button.textContent : null;
    if (button) { button.disabled = true; button.textContent = button.dataset.labelAdding || "Adding…"; }
    return fetch(cartAddUrl + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || "Could not add to cart."); });
        return r.json();
      })
      .then(function () { return refreshDrawer(); })
      .then(function () {
        openCart(true);
        if (button) {
          button.textContent = button.dataset.labelAdded || "Added";
          setTimeout(function () { button.disabled = false; button.textContent = original; }, 1500);
        }
      })
      .catch(function (err) {
        if (button) { button.disabled = false; button.textContent = original; }
        var box = $("[data-cart-error]");
        if (box) { box.textContent = err.message; box.hidden = false; }
        else window.location.href = routes.cart_url || "/cart";
      });
  }


  // v99 — personalized product: bypass Printify's submit handler and send the
  // exact Shopify variant + quantity + saved Personalization ID directly to Shopify.
  // The Printify app still owns the personalization editor/save flow; only Add to cart
  // is authoritative here.
  document.addEventListener('submit', function(e){
    var form = e.target && e.target.closest ? e.target.closest('form[data-native-printify-personalization="true"]') : null;
    if(!form) return;

    e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation();

    var nativeVariant = form.querySelector('[data-pod-id]');
    var chosenId = form.dataset.podSelectedVariantId || (nativeVariant && nativeVariant.value) || '';
    var qty = form.querySelector('[name="quantity"]');
    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : null;

    var source = new FormData(form);
    var projectPreview = source.get('properties[_Project Preview]');
    var projectPreviewBack = source.get('properties[_Project Preview Back]');
    var projectFrontImage = source.get('properties[_Project Front Image]');
    var projectBackImage = source.get('properties[_Project Back Image]');
    var projectFrontText = source.get('properties[Tekst przód]');
    var projectBackText = source.get('properties[Tekst tył]');
    var strategy = source.get('properties[_Printify Strategy]');
    var instructions = source.get('properties[_Printify Instructions]');
    var printifyVariant = source.get('properties[_Printify Variant ID]');

    if(!chosenId){
      var errBox=form.querySelector('[data-cart-error]');
      if(errBox){ errBox.textContent='Nie udało się ustalić wybranego wariantu.'; errBox.hidden=false; }
      return;
    }
    if(!projectPreview || !strategy || !instructions || !printifyVariant){
      var errBox2=form.querySelector('[data-cart-error]');
      if(errBox2){ errBox2.textContent='Najpierw kliknij „Generuj podgląd” i poczekaj, aż projekt będzie gotowy.'; errBox2.hidden=false; }
      return;
    }

    // v100: exact Shopify variant + opaque Printify headless personalization data
    // + the real rendered preview URL.
    var data = new FormData();
    data.set('id', String(chosenId));
    data.set('quantity', String((qty && qty.value) || '1'));
    data.set('properties[_Project Preview]', String(projectPreview));
    if(projectPreviewBack) data.set('properties[_Project Preview Back]', String(projectPreviewBack));
    if(projectFrontImage) data.set('properties[_Project Front Image]', String(projectFrontImage));
    if(projectBackImage) data.set('properties[_Project Back Image]', String(projectBackImage));
    if(projectFrontText) data.set('properties[Tekst przód]', String(projectFrontText));
    if(projectBackText) data.set('properties[Tekst tył]', String(projectBackText));
    data.set('properties[_Printify Strategy]', String(strategy));
    data.set('properties[_Printify Instructions]', String(instructions));
    data.set('properties[_Printify Variant ID]', String(printifyVariant));

    if(button){ button.disabled=true; button.textContent=button.dataset.labelAdding || 'DODAWANIE…'; }

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method:'POST',
      headers:{'Accept':'application/json'},
      body:data,
      credentials:'same-origin'
    }).then(function(r){
      return r.json().then(function(body){
        if(!r.ok) throw new Error(body.description || body.message || 'Nie udało się dodać produktu do koszyka.');
        return body;
      });
    }).then(function(){
      // Go to the canonical cart page so this test shows what Shopify truly stored.
      window.location.href=(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
    }).catch(function(err){
      if(button){ button.disabled=false; button.textContent=original; }
      var box=form.querySelector('[data-cart-error]');
      if(box){ box.textContent=err.message; box.hidden=false; }
      else alert(err.message);
    });
  }, true);

  // Formularze „dodaj do koszyka”.
  // WAŻNE: na stronie produktu wysyłamy pełny FormData, żeby zachować
  // właściwości line-item dodawane przez aplikacje (np. Printify Personalization).
  // v87: capture the product submit BEFORE embedded app listeners.
  // Printify can submit/rewrite its default variant during the normal bubble phase.
  // We stop that path and send one authoritative Shopify request ourselves, while
  // preserving every personalization property already written into the form.
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-cart-form]");
    if (!form || !useDrawer) return;

    // v97 — keep Printify's official native submit, but immediately before it
    // runs force EVERY Shopify variant field in the form to the variant chosen
    // in our storefront picker. We do not preventDefault here, so Printify can
    // still attach its saved personalization through its official app flow.
    if (form.matches('[data-native-printify-personalization="true"]')) {
      var nativeVariant = form.querySelector('[data-pod-id]');
      var chosenId = form.dataset.podSelectedVariantId || (nativeVariant && nativeVariant.value) || '';
      if (chosenId) {
        [].slice.call(form.querySelectorAll('[name="id"]')).forEach(function(ctrl){
          try { ctrl.value = String(chosenId); } catch(err) {}
        });
        if (nativeVariant) nativeVariant.value = String(chosenId);
      }
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // v93 — Shopify cart uses the authoritative variant ID selected by the storefront.
    // Diagnostic code removed. Printify personalization properties are preserved below.

    var button = $('[type="submit"]', form);
    var original = button ? button.textContent : null;
    if (button) { button.disabled = true; button.textContent = button.dataset.labelAdding || "DODAWANIE…"; }

    var data = new FormData(form);

    // v83 — the Printify Personalization app can inject its own `id` field
    // containing the variant that was active when the app initialized.
    // That creates duplicate `id` values in FormData and Shopify may add the
    // stale one (e.g. Sport Grey) even though the storefront shows Black.
    // Always make our product selector the single source of truth.
    var authoritativeVariant = form.querySelector('[data-pod-id]');
    // v91 — the storefront selection is the ONLY source of truth for Shopify.
    // Printify may rewrite/inject its own variant id after Save design, but that
    // must never change the item variant added to the Shopify cart.
    var selectedVariantId = form.dataset.podSelectedVariantId ||
      (authoritativeVariant && authoritativeVariant.value ? authoritativeVariant.value : '');
    if (selectedVariantId) {
      data.delete('id');
      data.set('id', selectedVariantId);
      // Restore the visible hidden input too, so all later submits stay aligned.
      if (authoritativeVariant) authoritativeVariant.value = selectedVariantId;
    }

    // Build a clean request: exactly ONE variant id + quantity + Printify
    // line-item properties. This prevents any stale app-level `id` from winning.
    var properties = {};
    data.forEach(function(value, key){
      var m = /^properties\[(.*)\]$/.exec(key);
      if (m && m[1]) properties[m[1]] = value;
    });
    // v95: postMessage from personalize.at is the most reliable confirmation
    // that the customer actually saved a design. Prefer that ID over stale app fields.
    if (form.dataset.podPersonalizationId) {
      properties['Personalization ID'] = form.dataset.podPersonalizationId;
    }
    var quantity = parseInt(data.get('quantity') || '1', 10);
    if (!quantity || quantity < 1) quantity = 1;
    var numericVariantId = Number(selectedVariantId);
    if (!numericVariantId) {
      if (button) { button.disabled = false; button.textContent = original; }
      var variantBox = $("[data-cart-error]", form);
      if (variantBox) { variantBox.textContent = "Wybierz poprawny wariant produktu."; variantBox.hidden = false; }
      return;
    }
    var payload = {
      items: [{
        id: numericVariantId,
        quantity: quantity,
        properties: properties
      }]
    };

    fetch(cartAddUrl + ".js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || "Nie udało się dodać produktu do koszyka."); });
        return r.json();
      })
      .then(function () { return refreshDrawer(); })
      .then(function () {
        openCart(true);
        if (button) {
          button.textContent = button.dataset.labelAdded || "DODANO";
          setTimeout(function () { button.disabled = false; button.textContent = original; }, 1500);
        }
      })
      .catch(function (err) {
        if (button) { button.disabled = false; button.textContent = original; }
        var box = $("[data-cart-error]");
        if (box) { box.textContent = err.message; box.hidden = false; }
        else window.location.href = routes.cart_url || "/cart";
      });
   }, true);

  // otwieranie / zamykanie
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) {
      if (!useDrawer) return;
      e.preventDefault();
      openCart(true);
      return;
    }
    if (e.target.closest("[data-cart-close]") || e.target.id === "cart-scrim") {
      openCart(false);
      return;
    }
    var rm = e.target.closest("[data-cart-remove]");
    if (rm) {
      e.preventDefault();
      rm.disabled = true;
      fetch(cartChangeUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: rm.dataset.cartRemove, quantity: 0 })
      }).then(refreshDrawer);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") openCart(false);
  });

  /* ---------------- wyszukiwarka podpowiadajaca ---------------- */
  var srch = $("#site-search");
  var srchInput = $("[data-search-input]", srch || document);
  var srchRes = $("[data-search-results]", srch || document);
  var srchOpeners = $$("[data-search-open]");

  if (srch && srchInput && srchRes) {
    var money = (function () {
      var iso = srch.getAttribute("data-currency") || "PLN";
      try {
        var nf = new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency", currency: iso
        });
        return function (raw) {
          if (raw === null || raw === undefined || raw === "") return "";
          var str = String(raw);
          // suggest.json podaje cene albo w groszach ("7400"), albo juz z kropka ("74.00")
          var val = str.indexOf(".") === -1 ? parseInt(str, 10) / 100 : parseFloat(str);
          return isNaN(val) ? "" : nf.format(val);
        };
      } catch (e) {
        return function (raw) { return String(raw || ""); };
      }
    })();

    function srchOpen(open) {
      if (open) {
        closeAcct();
        srch.hidden = false;
        // klasa dopiero w nastepnej klatce, inaczej przejscie sie nie odpali
        requestAnimationFrame(function () { srch.classList.add("on"); });
        setTimeout(function () { srchInput.focus(); }, 40);
      } else {
        srch.classList.remove("on");
        setTimeout(function () { if (!srch.classList.contains("on")) srch.hidden = true; }, 260);
      }
      srchOpeners.forEach(function (b) { b.setAttribute("aria-expanded", String(open)); });
    }

    closeSearch = function () { if (!srch.hidden) srchOpen(false); };

    srchOpeners.forEach(function (b) {
      b.addEventListener("click", function () { srchOpen(srch.hidden); });
    });
    $$("[data-search-close]").forEach(function (b) {
      b.addEventListener("click", function () { srchOpen(false); });
    });

    // klikniecie poza panelem zamyka; klikniecie w lupe obsluguje juz handler wyzej
    document.addEventListener("click", function (e) {
      if (srch.hidden) return;
      if (e.target.closest("#site-search") || e.target.closest("[data-search-open]")) return;
      srchOpen(false);
    });

    function esc(v) {
      return String(v == null ? "" : v)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }

    function hit(url, thumb, name, sub, price) {
      return '<a class="srch-hit" href="' + esc(url) + '">' +
        '<span class="srch-thumb">' + (thumb ? '<img src="' + esc(thumb) + '" alt="" loading="lazy">' : "") + "</span>" +
        '<span class="srch-txt"><span class="srch-nm">' + esc(name) + "</span>" +
        (sub ? '<span class="srch-sub">' + esc(sub) + "</span>" : "") + "</span>" +
        (price ? '<span class="srch-price">' + esc(price) + "</span>" : "") +
        "</a>";
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var pages = (r.pages || []).concat(r.articles || []);
      var html = "";

      if (products.length) {
        html += '<div class="srch-head">Products</div>';
        products.forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || "";
          if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2");
          html += hit(p.url, img, p.title, p.vendor || "", money(p.price));
        });
      }
      if (pages.length) {
        html += '<div class="srch-head">Pages</div>';
        pages.forEach(function (pg) { html += hit(pg.url, "", pg.title, "", ""); });
      }
      if (!html) {
        srchRes.innerHTML = '<p class="srch-note">Nothing found for &ldquo;' + esc(q) + '&rdquo;.</p>';
        return;
      }
      html += '<a class="srch-all" href="' + esc(routes.search_url || "/search") + "?q=" + encodeURIComponent(q) +
              '">See all results &rarr;</a>';
      srchRes.innerHTML = html;
    }

    var srchTimer = null, srchSeq = 0;
    srchInput.addEventListener("input", function () {
      var q = srchInput.value.trim();
      clearTimeout(srchTimer);
      if (q.length < 2) { srchRes.innerHTML = ""; return; }
      srchTimer = setTimeout(function () {
        var seq = ++srchSeq;
        var url = (routes.predictive_search_url || "/search/suggest") +
          ".json?q=" + encodeURIComponent(q) +
          "&resources[type]=product,page,article&resources[limit]=6";
        fetch(url, { headers: { Accept: "application/json" } })
          .then(function (res) { return res.json(); })
          .then(function (data) { if (seq === srchSeq) render(data, q); })
          .catch(function () {
            if (seq === srchSeq) srchRes.innerHTML = '<p class="srch-note">Search is unavailable right now.</p>';
          });
      }, 220);
    });

    // strzalki chodza po wynikach, Enter wchodzi w zaznaczony
    srchInput.addEventListener("keydown", function (e) {
      var hits = $$(".srch-hit", srchRes);
      if (!hits.length) return;
      var i = hits.indexOf($(".srch-hit.sel", srchRes));
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        if (i > -1) hits[i].classList.remove("sel");
        i = e.key === "ArrowDown" ? (i + 1) % hits.length : (i <= 0 ? hits.length - 1 : i - 1);
        hits[i].classList.add("sel");
        hits[i].scrollIntoView({ block: "nearest" });
      } else if (e.key === "Enter" && i > -1) {
        e.preventDefault();
        window.location.href = hits[i].href;
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !srch.hidden) { srchOpen(false); }
    });
  }

  /* ---------------- popover konta ---------------- */
  var acct = $("[data-acct]");
  if (acct) {
    var acctBtn = $("[data-acct-toggle]", acct);
    function acctOpen(open) {
      if (open) closeSearch();
      acct.classList.toggle("open", open);
      if (acctBtn) acctBtn.setAttribute("aria-expanded", String(open));
    }
    closeAcct = function () { acctOpen(false); };
    if (acctBtn) {
      // bez stopPropagation: zdarzenie musi dojsc do document, zeby zamknac
      // wyszukiwarke. Handler nizej i tak pomija klikniecia wewnatrz [data-acct].
      acctBtn.addEventListener("click", function () {
        acctOpen(!acct.classList.contains("open"));
      });
    }
    document.addEventListener("click", function (e) {
      if (!e.target.closest("[data-acct]")) acctOpen(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") acctOpen(false);
    });
    acct.addEventListener("focusout", function () {
      setTimeout(function () {
        if (!acct.contains(document.activeElement)) acctOpen(false);
      }, 0);
    });
  }

  /* ---------------- kursor i magnetyczne przyciski ---------------- */
  var cursor = $("#cursor");
  if (cursor && hoverable && !reduce) {
    var cx = window.innerWidth / 2, cy = window.innerHeight / 2, tx = cx, ty = cy;
    window.addEventListener("mousemove", function (e) {
      tx = e.clientX; ty = e.clientY;
      cursor.classList.add("live");
      var t = e.target;
      cursor.classList.toggle("big", !!(t.closest && t.closest("a,button,.card,input,select")));
    }, { passive: true });
    (function loop() {
      cx += (tx - cx) * 0.18;
      cy += (ty - cy) * 0.18;
      cursor.style.transform = "translate3d(" + cx + "px," + cy + "px,0)";
      requestAnimationFrame(loop);
    })();

    $$(".mag").forEach(function (el) {
      el.addEventListener("mousemove", function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = "translate(" +
          ((e.clientX - r.left - r.width / 2) * 0.2).toFixed(1) + "px," +
          ((e.clientY - r.top - r.height / 2) * 0.28).toFixed(1) + "px)";
      });
      el.addEventListener("mouseleave", function () { el.style.transform = ""; });
    });
  }

  /* ---------------- naglowek hero: podzial na linie ----------------
     Kazda linia dostaje wlasna maske, zeby wjezdzaly po kolei, a nie
     jednym blokiem. Robimy to przed obserwatorem nizej, bo to on nadaje
     klase "in". Gdy podzial sie nie uda, zostaje stary reveal calego H1. */
  (function () {
    var h1 = $(".hero .h1");
    if (!h1 || h1.innerHTML.indexOf("<br") === -1) return;
    var lines = h1.innerHTML.split(/<br\s*\/?>/i);
    if (lines.length < 2) return;
    h1.innerHTML = lines.map(function (ln) {
      return '<span class="hl"><span class="hl-i">' + ln + "</span></span>";
    }).join("");
    h1.classList.add("split");
  })();

  /* ---------------- odslanianie przy scrollu ---------------- */
  var revealables = $$(".rv,.rv-up,.rv-img");
  if (revealables.length && !reduce && "IntersectionObserver" in window) {
    // Stan poczatkowy wlaczamy dopiero stad. Bez JS albo przy jego bledzie
    // tresc jest normalnie widoczna — naglowek strony i zdjecie produktu
    // nie moga zalezec od tego, czy observer zadzialal.
    document.documentElement.classList.add("rv-on");

    // Nigdy nie obserwujemy elementu, ktory sam sie ukrywa. IntersectionObserver
    // liczy widocznosc PO transformacji i przycieciu, wiec naglowek przesuniety
    // o wlasna wysokosc albo obraz z clip-path do zera nigdy nie zglosza wejscia
    // w kadr i nigdy sie nie odslonia. Obserwujemy nieruchoma sekcje.
    var hosts = [];
    revealables.forEach(function (el) {
      var host = el.closest(".section") || el.parentElement || el;
      if (hosts.indexOf(host) === -1) hosts.push(host);
    });

    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        $$(".rv,.rv-up,.rv-img", en.target).forEach(function (el) {
          el.classList.add("in");
        });
        rio.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0 });

    hosts.forEach(function (h) { rio.observe(h); });
  }

  /* ---------------- galeria na karcie produktu ---------------- */
  $$("[data-gallery]").forEach(function (gal) {
    var main = $("[data-gallery-main]", gal.closest("[data-product-media]") || document);
    gal.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-media-src]");
      if (!b || !main) return;
      $$("button", gal).forEach(function (x) { x.classList.toggle("on", x === b); });
      main.src = b.dataset.mediaSrc;
      main.srcset = b.dataset.mediaSrcset || "";
    });
  });
})();

// v100 — CIACHLASER headless Printify personalization + real rendered preview.
(function(){
  var root=document.querySelector('[data-pod-product][data-is-personalized="true"]');
  if(!root) return;
  var box=root.querySelector('[data-headless-personalizer]');
  var form=root.querySelector('form[data-pod-form]');
  if(!box||!form) return;
  var worker=box.getAttribute('data-worker');
  var cachedEmptyImage=null;
  var btn=box.querySelector('[data-generate-preview]');
  var status=box.querySelector('[data-preview-status]');
  var previewWrap=box.querySelector('[data-generated-preview]');
  var previewImg=box.querySelector('[data-generated-preview-img]');
  var previewBack=box.querySelector('[data-generated-preview-back]');
  var previewBackWrap=box.querySelector('[data-generated-preview-back-wrap]');
  var outPreview=box.querySelector('[data-project-preview]');
  var outPreviewBack=box.querySelector('[data-project-preview-back]');
  var outFrontImage=box.querySelector('[data-project-front-image]');
  var outBackImage=box.querySelector('[data-project-back-image]');
  var outFrontText=box.querySelector('[data-project-front-text]');
  var outBackText=box.querySelector('[data-project-back-text]');
  var outStrategy=box.querySelector('[data-printify-strategy]');
  var outInstructions=box.querySelector('[data-printify-instructions]');
  var outVariant=box.querySelector('[data-printify-variant]');
  var cachedProduct=null;

  function setStatus(msg,bad){ status.hidden=false; status.textContent=msg; status.style.color=bad?'#B3261E':''; }
  function api(path,opts){ opts=opts||{}; return fetch(worker+path,Object.assign({headers:{'Accept':'application/json','Content-Type':'application/json'}},opts)).then(function(r){return r.json().then(function(j){if(!r.ok||j.ok===false){var d=(j&&j.debug)||(j&&j.printify_response)||(j&&j.personalization)||(j&&j.preview)||{};var reason=(d.errors&&d.errors.reason)||(d.error&&d.error.message)||d.message;throw new Error(reason||(j&&j.error)||'Błąd Printify');}return j;});}); }
  function file64(file){ return new Promise(function(resolve,reject){var r=new FileReader();r.onload=function(){resolve(String(r.result).split('base64,').pop())};r.onerror=reject;r.readAsDataURL(file);}); }
  function upload(file){ if(!file)return Promise.resolve(null); if(file.size>8*1024*1024)return Promise.reject(new Error('Zdjęcie jest za duże. Użyj pliku do 8 MB.')); return file64(file).then(function(contents){return api('/upload-image',{method:'POST',body:JSON.stringify({file_name:file.name,contents:contents})});}).then(function(j){return j.image;}); }
  function textAsPngFile(text,side){
    text=String(text||'').trim();
    if(!text)return Promise.resolve(null);
    return new Promise(function(resolve,reject){
      try{
        var canvas=document.createElement('canvas');
        // Text-only artwork: use a shorter transparent canvas so the lettering
        // occupies much more of Printify's printable area instead of looking tiny.
        canvas.width=1800;canvas.height=1050;
        var ctx=canvas.getContext('2d');
        ctx.clearRect(0,0,canvas.width,canvas.height);
        // Automatically choose readable lettering for the selected shirt color.
        // White / Sport Grey -> dark text; Black / Dark Heather -> white text.
        var selectedColorValues=[].slice.call(root.querySelectorAll('[data-pod-option]')).map(function(el){
          return String(el.value||'').trim().toLowerCase();
        });
        var darkShirt=selectedColorValues.some(function(v){
          return v==='black' || v==='czarny' || v.indexOf('dark heather')>-1;
        });
        ctx.fillStyle=darkShirt?'#FFFFFF':'#111111';
        ctx.textAlign='center';ctx.textBaseline='middle';
        var maxWidth=1540, fontSize=430;
        var textFont='Impact, Haettenschweiler, \"Arial Narrow Bold\", \"Arial Narrow\", sans-serif';

        function makeLines(size){
          ctx.font='900 '+size+'px '+textFont;
          var words=text.split(/\s+/), out=[], line='';
          words.forEach(function(word){
            var test=line?line+' '+word:word;
            if(ctx.measureText(test).width>maxWidth&&line){out.push(line);line=word;}else{line=test;}
          });
          if(line)out.push(line);
          return out;
        }

        var lines=makeLines(fontSize);
        // Keep normal customer phrases large; shrink only when they truly need it.
        while(fontSize>170 && (lines.length>2 || lines.some(function(l){return ctx.measureText(l).width>maxWidth;}))){
          fontSize-=12;
          lines=makeLines(fontSize);
        }
        ctx.font='900 '+fontSize+'px '+textFont;
        var lineHeight=Math.round(fontSize*1.06);
        var y=canvas.height/2-((lines.length-1)*lineHeight)/2;
        lines.forEach(function(l,i){ctx.fillText(l,canvas.width/2,y+i*lineHeight,maxWidth);});
        canvas.toBlob(function(blob){
          if(!blob){reject(new Error('Nie udało się przygotować grafiki z tekstem.'));return;}
          try{resolve(new File([blob],'ciachlaser-text-'+side+'.png',{type:'image/png'}));}
          catch(e){blob.name='ciachlaser-text-'+side+'.png';resolve(blob);}
        },'image/png');
      }catch(e){reject(e);}
    });
  }
  function uploadEmptyImage(){
    if(cachedEmptyImage)return Promise.resolve(cachedEmptyImage);
    // Valid transparent 1000x1000 PNG. Large enough for Printify upload validation,
    // uploaded through our Worker so Printify hosts it and returns an HTTPS preview_url.
    var pngBase64='iVBORw0KGgoAAAANSUhEUgAAA+gAAAPoCAYAAABNo9TkAAAPPElEQVR42u3BAQ0AAADCoPdPbQ43oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIB3AxB7AAFVmiFdAAAAAElFTkSuQmCC';
    return api('/upload-image',{method:'POST',body:JSON.stringify({file_name:'ciachlaser-empty.png',contents:pngBase64})}).then(function(j){cachedEmptyImage=j.image;return cachedEmptyImage;});
  }
  function selectedValues(){return [].slice.call(root.querySelectorAll('[data-pod-option]')).map(function(s){return s.value;});}
  function norm(x){return String(x||'').trim().toLowerCase().replace(/grey/g,'gray');}
  function loadProduct(){ if(cachedProduct)return Promise.resolve(cachedProduct); return api('/product').then(function(j){cachedProduct=j.product;return cachedProduct;}); }
  function printifyVariant(product,values){
    var wanted=values.map(norm), optionIds=[];
    (product.options||[]).forEach(function(opt){ var hit=(opt.values||[]).find(function(v){return wanted.indexOf(norm(v.title))>-1;}); if(hit)optionIds.push(Number(hit.id)); });
    return (product.variants||[]).find(function(v){var ids=(v.options||[]).map(Number);return optionIds.length===wanted.length && optionIds.every(function(id){return ids.indexOf(id)>-1;});});
  }
  function poll(taskId,tries){ tries=tries||0; if(tries>30)return Promise.reject(new Error('Printify zbyt długo generuje podgląd. Spróbuj ponownie.')); return api('/preview-status?task_id='+encodeURIComponent(taskId)).then(function(j){var t=j.task||{};if(t.status==='completed')return t;if(t.status==='failed'||t.status==='corrupt')throw new Error((t.error&&t.error.message)||'Nie udało się wygenerować podglądu.');return new Promise(function(res){setTimeout(res,1500)}).then(function(){return poll(taskId,tries+1)});}); }

  function resetPreview(){outPreview.value='';if(outPreviewBack)outPreviewBack.value='';if(outFrontImage)outFrontImage.value='';if(outBackImage)outBackImage.value='';if(outFrontText)outFrontText.value='';if(outBackText)outBackText.value='';outStrategy.value='';outInstructions.value='';outVariant.value='';previewWrap.hidden=true;if(previewBackWrap)previewBackWrap.hidden=true;}
  root.addEventListener('change',function(e){if(e.target&&e.target.matches('[data-pod-option]'))resetPreview();});

  btn.addEventListener('click',function(){
    resetPreview();
    var frontFile=box.querySelector('[data-custom-image-front]').files[0]||null;
    var backFile=box.querySelector('[data-custom-image-back]').files[0]||null;
    var frontText=box.querySelector('[data-custom-text-front]').value.trim();
    var backText=box.querySelector('[data-custom-text-back]').value.trim();
    if(!frontFile&&!backFile&&!frontText&&!backText){setStatus('Dodaj przynajmniej zdjęcie albo tekst.',true);return;}
    btn.disabled=true;btn.textContent='PRZYGOTOWUJĘ PROJEKT…';setStatus('Wysyłam materiały i przygotowuję podgląd Printify…',false);
    // Gdy klient poda sam tekst bez zdjęcia, zamieniamy tekst na przezroczystą PNG.
    // Dzięki temu Printify umieszcza go w centralnym polu grafiki zamiast na dole pola tekstowego.
    Promise.all([
      loadProduct(),
      frontFile?upload(frontFile):(frontText?textAsPngFile(frontText,'front').then(upload):Promise.resolve(null)),
      backFile?upload(backFile):(backText?textAsPngFile(backText,'back').then(upload):Promise.resolve(null))
    ]).then(function(all){
      var product=all[0], frontImage=all[1], backImage=all[2];
      var frontTextForPrintify=(!frontFile&&frontText)?'':frontText;
      var backTextForPrintify=(!backFile&&backText)?'':backText;
      var pv=printifyVariant(product,selectedValues());
      if(!pv)throw new Error('Nie udało się dopasować wybranego koloru i rozmiaru do Printify.');
      function absoluteImageUrl(url){ url=String(url||'').trim(); if(url.indexOf('//')===0)return 'https:'+url; if(url && !/^https?:\/\//i.test(url)){try{return new URL(url,location.origin).href}catch(e){}} return url;}
      function uploadedUrl(img){return absoluteImageUrl(img&&(img.preview_url||img.url||img.src)||'');}
      var frontUrl=uploadedUrl(frontImage);
      var backUrl=uploadedUrl(backImage);
      // Printify validates all four configured layers. If an optional image is empty,
      // upload a real transparent PNG to Printify first instead of using a Shopify CDN URL.
      var needEmpty=!frontUrl||!backUrl;
      return (needEmpty?uploadEmptyImage():Promise.resolve(null)).then(function(emptyImage){
        var emptyUrl=uploadedUrl(emptyImage);
        frontUrl=frontUrl||emptyUrl;
        backUrl=backUrl||emptyUrl;
        if(outFrontImage)outFrontImage.value=frontImage?frontUrl:'';
        if(outBackImage)outBackImage.value=backImage?backUrl:'';
        if(outFrontText)outFrontText.value=frontText;
        if(outBackText)outBackText.value=backText;
        if(!frontUrl||!backUrl)throw new Error('Nie udało się przygotować pustej warstwy obrazu w Printify.');
        var items=[
          {field_id:'zdjecie-przod',type:'image',input:{image_url:frontUrl}},
          {field_id:'twoj-tekst-przod',type:'textbox',input:{text:frontTextForPrintify||''}},
          {field_id:'zdjecie-tyl',type:'image',input:{image_url:backUrl}},
          {field_id:'twoj-tekst-tyl',type:'textbox',input:{text:backTextForPrintify||''}}
        ];
        outVariant.value=String(pv.id);
        return api('/personalize',{method:'POST',body:JSON.stringify({variant_id:pv.id,items:items})}).then(function(cfgResponse){
          return api('/preview',{method:'POST',body:JSON.stringify({variant_ids:[pv.id],personalization:items})}).then(function(previewResponse){
            return {config:cfgResponse.personalization,preview:previewResponse.preview};
          });
        });
      });
    }).then(function(r){
      var cfg=r.config||{};outStrategy.value=cfg.personalisation_strategy||'';outInstructions.value=cfg.personalisation_instructions||'';
      if(!r.preview||!r.preview.task_id)throw new Error('Printify nie zwrócił numeru zadania podglądu.');
      setStatus('Renderuję prawdziwy mockup Twojego projektu…',false);return poll(r.preview.task_id);
    }).then(function(task){
      var mockups=(task.mockups||[]).filter(function(m){return m&&m.src;});
      var m=mockups[0];if(!m)throw new Error('Printify nie zwrócił obrazu podglądu.');
      outPreview.value=m.src;previewImg.src=m.src;
      var back=mockups.length>1?mockups[1]:null;
      if(outPreviewBack)outPreviewBack.value=back?back.src:'';
      if(previewBack&&previewBackWrap){if(back){previewBack.src=back.src;previewBackWrap.hidden=false;}else{previewBackWrap.hidden=true;}}
      previewWrap.hidden=false;setStatus('Podgląd gotowy ✓ Projekt został zapisany i możesz dodać go do koszyka.',false);

      // v108 — make the generated Printify mockup authoritative for the large gallery image.
      // Shopify images often keep a responsive srcset, which can override a plain `src` assignment.
      function showGeneratedMockup(src){
        if(!src)return;
        var main=root.querySelector('[data-pod-main]');
        if(!main)return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.srcset='';
        main.src=src;
        main.dataset.originalSrc=src;
        main.dataset.generatedPreview='true';
        var selectedId=form && (form.dataset.podSelectedVariantId || (form.querySelector('[name="id"]')||{}).value);
        main.dataset.generatedVariantId=String(selectedId||'');
        // Also update the active thumbnail so clicking it cannot restore the old product image.
        var active=root.querySelector('[data-pod-gallery] button.on, [data-pod-gallery] .pod-gallery-thumb.on');
        if(active){
          active.dataset.src=src;
          active.dataset.mediaSrc=src;
          active.dataset.mediaSrcset='';
          var thumb=active.querySelector('img');
          if(thumb){thumb.removeAttribute('srcset');thumb.removeAttribute('sizes');thumb.src=src;}
        }
      }
      showGeneratedMockup(m.src);

      // The two generated preview cards can also drive the large image (front/back).
      if(previewImg)previewImg.onclick=function(){showGeneratedMockup(m.src);};
      if(previewBack&&back)previewBack.onclick=function(){showGeneratedMockup(back.src);};
    }).catch(function(err){setStatus(err.message||String(err),true);}).finally(function(){btn.disabled=false;btn.textContent='GENERUJ PODGLĄD';});
  });
})();
